<template>
	<div class="bg-green relative mt-4 pt-1">
		<div
			class="relative flex aspect-square w-full flex-col items-center justify-center overflow-hidden bg-black"
		>
			<div
				class="absolute inset-0 bg-black transition-opacity duration-500"
				:class="{ 'opacity-0': scene !== 0 && scene !== 1 }"
			>
				<svg
					width="100%"
					height="100%"
					preserveAspectRatio="xMidYMid slice"
					viewBox="0 0 1280 1280"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					class="block object-cover"
				>
					<g clip-path="url(#clip0_1837_3214)">
						<mask
							id="mask0_1837_3214"
							style="mask-type: alpha"
							maskUnits="userSpaceOnUse"
							x="-45"
							y="209"
							width="1369"
							height="862"
						>
							<rect
								x="1324"
								y="1071"
								width="1368.43"
								height="862"
								transform="rotate(180 1324 1071)"
								fill="url(#paint0_radial_1837_3214)"
							/>
						</mask>
						<g mask="url(#mask0_1837_3214)">
							<path
								opacity="0.1"
								d="M-453.66 276.694H1747.82V283.676H-453.66V276.694ZM-453.66 309.776H1747.82V316.758H-453.66V309.776ZM-453.66 342.852H1747.82V349.834H-453.66V342.852ZM-453.66 375.929H1747.82V382.912H-453.66V375.929ZM-453.66 409.008H1747.82V415.991H-453.66V409.008ZM-453.66 442.087H1747.82V449.07H-453.66V442.087ZM-453.66 475.162H1747.82V482.144H-453.66V475.162ZM-453.66 508.241H1747.82V515.223H-453.66V508.241ZM-453.66 541.32H1747.82V548.302H-453.66V541.32ZM-453.66 574.397H1747.82V581.379H-453.66V574.397ZM-453.66 607.472H1747.82V614.455H-453.66V607.472ZM-453.66 640.551H1747.82V647.534H-453.66V640.551ZM-453.66 673.628H1747.82V680.612H-453.66V673.628ZM-453.66 706.708H1747.82V713.691H-453.66V706.708ZM-453.66 739.782H1747.82V746.764H-453.66V739.782ZM-453.66 772.861H1747.82V779.843H-453.66V772.861ZM-453.66 805.94H1747.82V812.922H-453.66V805.94ZM-453.66 839.023H1747.82V846.005H-453.66V839.023ZM-453.66 872.096H1747.82V879.079H-453.66V872.096ZM-453.66 905.175H1747.82V912.158H-453.66V905.175ZM-453.66 938.254H1747.82V945.237H-453.66V938.254ZM-453.66 971.333H1747.82V978.317H-453.66V971.333ZM-453.66 1004.41H1747.82V1011.39H-453.66V1004.41Z"
								fill="#878787"
							/>
						</g>
					</g>
					<defs>
						<radialGradient
							id="paint0_radial_1837_3214"
							cx="0"
							cy="0"
							r="1"
							gradientUnits="userSpaceOnUse"
							gradientTransform="translate(2008.21 1502) rotate(180) scale(684.213 431)"
						>
							<stop offset="0.246979" stop-color="#0A1119" />
							<stop offset="1" stop-color="#33567F" stop-opacity="0" />
						</radialGradient>
						<clipPath id="clip0_1837_3214">
							<rect width="1280" height="1280" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</div>
			<div
				class="absolute inset-0 bg-radial-(--battles-gradient) transition-opacity duration-1000"
				:class="{ 'opacity-0': scene < 2 }"
			></div>
			<div
				class="absolute inset-0 bg-radial-(--cases-gradient) transition-opacity duration-1000"
				:class="{ 'opacity-0': scene < 3 }"
			></div>
			<div
				class="absolute inset-0 bg-black transition-opacity duration-1000"
				:class="{ 'opacity-0': scene < 4 }"
			>
				<svg
					width="100%"
					height="100%"
					preserveAspectRatio="xMidYMid slice"
					viewBox="0 0 1280 1280"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					class="block object-cover"
				>
					<g clip-path="url(#clip0_1837_3214)">
						<mask
							id="mask0_1837_3214"
							style="mask-type: alpha"
							maskUnits="userSpaceOnUse"
							x="-45"
							y="209"
							width="1369"
							height="862"
						>
							<rect
								x="1324"
								y="1071"
								width="1368.43"
								height="862"
								transform="rotate(180 1324 1071)"
								fill="url(#paint0_radial_1837_3214)"
							/>
						</mask>
						<g mask="url(#mask0_1837_3214)">
							<path
								opacity="0.1"
								d="M-453.66 276.694H1747.82V283.676H-453.66V276.694ZM-453.66 309.776H1747.82V316.758H-453.66V309.776ZM-453.66 342.852H1747.82V349.834H-453.66V342.852ZM-453.66 375.929H1747.82V382.912H-453.66V375.929ZM-453.66 409.008H1747.82V415.991H-453.66V409.008ZM-453.66 442.087H1747.82V449.07H-453.66V442.087ZM-453.66 475.162H1747.82V482.144H-453.66V475.162ZM-453.66 508.241H1747.82V515.223H-453.66V508.241ZM-453.66 541.32H1747.82V548.302H-453.66V541.32ZM-453.66 574.397H1747.82V581.379H-453.66V574.397ZM-453.66 607.472H1747.82V614.455H-453.66V607.472ZM-453.66 640.551H1747.82V647.534H-453.66V640.551ZM-453.66 673.628H1747.82V680.612H-453.66V673.628ZM-453.66 706.708H1747.82V713.691H-453.66V706.708ZM-453.66 739.782H1747.82V746.764H-453.66V739.782ZM-453.66 772.861H1747.82V779.843H-453.66V772.861ZM-453.66 805.94H1747.82V812.922H-453.66V805.94ZM-453.66 839.023H1747.82V846.005H-453.66V839.023ZM-453.66 872.096H1747.82V879.079H-453.66V872.096ZM-453.66 905.175H1747.82V912.158H-453.66V905.175ZM-453.66 938.254H1747.82V945.237H-453.66V938.254ZM-453.66 971.333H1747.82V978.317H-453.66V971.333ZM-453.66 1004.41H1747.82V1011.39H-453.66V1004.41Z"
								fill="#878787"
							/>
						</g>
					</g>
					<defs>
						<radialGradient
							id="paint0_radial_1837_3214"
							cx="0"
							cy="0"
							r="1"
							gradientUnits="userSpaceOnUse"
							gradientTransform="translate(2008.21 1502) rotate(180) scale(684.213 431)"
						>
							<stop offset="0.246979" stop-color="#0A1119" />
							<stop offset="1" stop-color="#33567F" stop-opacity="0" />
						</radialGradient>
						<clipPath id="clip0_1837_3214">
							<rect width="1280" height="1280" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</div>
			<div
				class="absolute inset-0 bg-black transition-opacity duration-1000"
				:class="{ 'opacity-0': scene < 5 }"
			></div>

			<!-- Scene 0 - 1: Logo animation -->
			<template v-if="scene === 0 || scene === 1">
				<div
					class="text-label-secondary absolute top-5 right-0 left-0 flex items-center justify-center gap-1.5 text-center transition-all duration-500"
					:class="{ '-translate-y-full opacity-0': !showIntroText }"
				>
					<ShieldIcon class="h-5 w-5" />
					<div>{{ t('fairness') }}</div>
				</div>
				<div class="logo-container" :class="animationPhase">
					<img :src="LogoTextColorNewIcon" class="logo-image" />
				</div>
				<div
					class="text-label-secondary border-separator-secondary absolute right-0 bottom-0 left-0 flex items-center justify-center gap-3 border-t border-dashed bg-black px-6 transition-all duration-500"
					:class="{ 'translate-y-full opacity-0': !showIntroText }"
				>
					<LazyImage
						src="https://rage.gift/cdn/cases/019b22ad-ab33-8aa0-b035-fe7214720cdc.png"
						alt="case"
						class="h-24 w-24"
					/>
					<div>
						<div
							class="text-label-primary font-squad text-lg font-black uppercase"
						>
							{{ t('freeCases') }}
						</div>
						<div class="text-label-secondary mt-1 text-base">
							{{ t('openAndClaim') }}
						</div>
					</div>
				</div>
			</template>

			<!-- Scene 2: Roulette with text -->
			<div
				class="roulette-scene absolute inset-0 transition-opacity duration-500"
				:class="{ 'opacity-0': scene !== 2 }"
			>
				<div class="exciting-text" :class="{ 'text-visible': showText }">
					{{ t('cases') }}
				</div>
				<LazyImage
					class="absolute! -bottom-30 left-1/2 h-75 w-75 -translate-x-1/2 opacity-60 blur-sm transition-all duration-400"
					:class="{
						'bottom-10! h-50! w-50! opacity-100! blur-none!': !showRoulette
					}"
					src="https://rage.gift/cdn/cases/019b21de-498b-86c5-a4cc-69180cc9f279.png"
					alt="case"
				/>
				<ItemRoulette
					:class="{ 'opacity-0': !showRoulette }"
					class="relative -translate-y-15 transition-opacity duration-400"
					ref="rouletteRef1"
					:items="rouletteItems"
					:casePrice="100"
					:horizontal="true"
					:startOffset="0"
					seed="123"
					noBg
				/>
			</div>

			<div
				class="roulette-scene absolute inset-0 justify-center! transition-opacity duration-500"
				:class="{ 'opacity-0': scene !== 3 }"
			>
				<div class="exciting-text mt-4" :class="{ 'text-visible': showText }">
					{{ t('battles') }}
				</div>
				<div class="relative h-30 w-full">
					<BattleTieBreak
						class="translate-y-5"
						ref="tieBreak"
						seed="123"
						noBg
					/>
				</div>
				<div class="exciting-text" :class="{ 'text-visible': showText }">
					{{ t('players') }}
				</div>
			</div>

			<div
				class="roulette-scene absolute inset-0 justify-center! gap-0! transition-opacity duration-500"
				:class="{ 'opacity-0': scene !== 4 && scene !== 3 }"
			>
				<div
					class="font-squad text-label-primary text-center text-3xl font-black uppercase transition-all duration-300"
					:class="{ 'translate-y-full opacity-0': !showText || scene !== 4 }"
				>
					{{ t('fair') }},<br />
					{{ t('always') }}
				</div>
				<LazySticker
					class="mt-1 h-40 w-40 transition-all duration-400"
					:class="{ 'translate-y-10 opacity-0': !showText || scene !== 4 }"
					src="https://rage.gift/cdn/animations/019a01f2-65e6-8179-87c1-f10e7ea9ca34.tgs"
					ref="sticker"
				/>
				<div
					class="text-label-secondary mt-6 transition-all duration-500"
					:class="{ 'translate-y-full opacity-0': !showText || scene !== 4 }"
				>
					{{ t('based') }}
				</div>
				<div
					class="text-label-secondary mt-1 transition-all duration-600"
					:class="{ 'translate-y-full opacity-0': !showText || scene !== 4 }"
				>
					<span
						>{{ t('only') }}<b class="text-label-primary">@ragegift</b></span
					>
				</div>
				<BattleEnd
					class="inset-10!"
					:participants="[
						{ name: 'Ms.Rage', teamIndex: 0, winner: { wonCoins: 5619900 } }
					]"
					noBg
					:wonCoins="5619900"
					:price="1"
					:rounds="[
						{
							results: [
								{
									item: {
										modelUuid: '01982e21-1b68-791b-95c2-e49122929f8f',
										price: 123,
										preloader: null
									}
								},
								{
									item: {
										modelUuid: '01982dcd-8ac2-7a0b-a2c7-8bc60ecf00ef',
										price: 123,
										preloader: null
									}
								},
								{
									item: {
										modelUuid: '01982dcc-a821-7ec5-917f-791c468b093c',
										price: 123,
										preloader: null
									}
								}
							]
						}
					]"
					:show="battleEnd"
					:duration="2000"
				/>
			</div>
		</div>
		<BaseButton
			@click="startSequence"
			size="lg"
			color="primary"
			class="mt-10 w-full"
		>
			Start sequence
		</BaseButton>
	</div>
</template>
<script setup lang="ts">
import BaseButton from '@/components/BaseButton.vue'
import ItemRoulette from '@/components/ItemRoulette.vue'
import { sleep } from '@/utils/sleep'
import { nextTick, ref } from 'vue'
import LogoTextColorNewIcon from '@/assets/icons/logo-text-color-new.svg?url'
import BattleTieBreak from '@/components/BattleTieBreak.vue'
import BattleEnd from '@/components/BattleEnd.vue'
import LazySticker from '@/components/LazySticker.vue'
import LazyImage from '@/components/LazyImage.vue'
import ShieldIcon from '@/assets/icons/shield.svg'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	messages: {
		en: {
			fairness: 'Fairness Guaranteed by TON',
			freeCases: '3 Free Cases',
			openAndClaim: 'Open and Claim',
			cases: 'EXCITING CASES',
			battles: 'THRILLING BATTLES',
			players: 'UP TO 4 PLAYERS',
			fair: 'PROVABLY FAIR',
			always: 'ALWAYS',
			based: 'Based on TON Blockchain',
			only: 'Only on '
		},
		ru: {
			fairness: 'Честность гарантирована TON',
			freeCases: '3 бесплатных кейса',
			openAndClaim: 'Зайди и забери',
			cases: 'ТОПОВЫЕ КЕЙСЫ',
			battles: 'ЗАХВАТЫВАЮЩИЕ БАТЛЫ',
			players: 'ДО 4х ИГРОКОВ',
			fair: 'ЧЕСТНАЯ ИГРА',
			always: 'ВСЕГДА',
			based: 'Основано на TON блокчейне',
			only: 'Только на '
		}
	}
})

const scene = ref(-1)
const animationPhase = ref('')
const showIntroText = ref(false)
const showText = ref(false)
const showRoulette = ref(false)
const rouletteRef1 = ref<InstanceType<typeof ItemRoulette> | null>(null)
const tieBreak = ref<InstanceType<typeof BattleTieBreak> | null>(null)
const battleEnd = ref(false)
const sticker = ref<InstanceType<typeof LazySticker> | null>(null)

// Mock items for the roulette - [src, preloader, price]
const rouletteItems: [string, string | null, number][] = [
	[
		'https://rage.gift/cdn/icons/01982e20-dff8-7258-88eb-450c6676d2d4.png',
		null,
		50
	],
	[
		'https://rage.gift/cdn/icons/01982dcf-4794-7e32-993e-a53ae0368953.png',
		null,
		75
	],
	[
		'https://rage.gift/cdn/icons/01982dcf-4794-7e32-993e-a53ae0368953.png',
		null,
		150
	],
	[
		'https://rage.gift/cdn/icons/01982dcf-4794-7e32-993e-a53ae0368953.png',
		null,
		200
	],
	[
		'https://rage.gift/cdn/icons/01982dcf-4794-7e32-993e-a53ae0368953.png',
		null,
		500
	],
	[
		'https://rage.gift/cdn/animations/01982dcc-a639-71fc-a3bc-525579554587.tgs',
		null,
		1000
	]
]

const startSequence = async () => {
	scene.value = 0
	animationPhase.value = ''
	showText.value = false

	await sleep(50) // Allow DOM to update

	// Phase 1: Fade in as square (2 seconds)
	animationPhase.value = 'phase-fade-in'

	await sleep(2000)

	showIntroText.value = true

	// Phase 2: Unfold and scale down
	animationPhase.value = 'phase-fade-in phase-unfold phase-scale-down'

	scene.value = 1

	await sleep(5000)

	// Phase 3: Swipe logo left and transition to scene 1
	animationPhase.value =
		'phase-fade-in phase-unfold phase-scale-down phase-swipe-left'

	scene.value = 2

	// Show text with animation
	showText.value = true
	showRoulette.value = false

	await sleep(400)

	showRoulette.value = true

	// Start rolling the roulette with an expensive item
	if (rouletteRef1.value) {
		rouletteRef1.value.roll(
			{
				src: 'https://rage.gift/cdn/animations/01982dcc-a639-71fc-a3bc-525579554587.tgs',
				imgSrc:
					'https://rage.gift/cdn/icons/01982dcc-a639-71fc-a3bc-525579554587.png',
				preloader: null,
				price: 1000,
				chance: 0.5
			},
			true
		)
	}

	await sleep(4000)

	showText.value = false

	await sleep(600)

	showText.value = true
	scene.value = 3

	if (tieBreak.value) {
		tieBreak.value.roll(
			[
				['https://rage.gift/cdn/bots/msrage.png', 0, 0],
				['https://rage.gift/cdn/bots/srrage.png', 0, 0]
			],
			['https://rage.gift/cdn/bots/msrage.png', 0]
		)
	}

	await sleep(4400)

	showText.value = false

	battleEnd.value = true

	await sleep(600)

	scene.value = 4

	await sleep(1600)

	battleEnd.value = false

	await sleep(600)

	showText.value = true

	if (sticker.value) {
		sticker.value.play()
	}

	await sleep(2800)

	scene.value = 5
}
</script>
<style scoped lang="css">
.logo-container {
	position: relative;
	width: 70px;
	height: 68px;
	overflow: hidden;
	opacity: 0;
	transform: scale(1.1);
}

.logo-image {
	width: 360px;
	max-width: none;
	height: auto;
}

/* Phase 1: Fade in as square logo */
.phase-fade-in {
	animation: fadeInSquare 2s ease-out forwards;
}

@keyframes fadeInSquare {
	0% {
		opacity: 0;
		transform: scale(1.1);
	}
	100% {
		opacity: 1;
		transform: scale(1);
	}
}

/* Phase 2: Unfold */
.phase-unfold {
	animation:
		fadeInSquare 2s ease-out forwards,
		unfold 0.4s ease-out forwards;
}

@keyframes unfold {
	0% {
		width: 70px;
		transform: scale(1);
	}
	100% {
		width: 360px;
		transform: scale(0.85);
	}
}

/* Phase 3: Continue scaling down */
.phase-scale-down {
	animation:
		fadeInSquare 2s ease-out forwards,
		unfold 0.4s ease-out forwards,
		scaleDown 5s ease-out 0.4s forwards;
}

@keyframes scaleDown {
	0% {
		width: 360px;
		transform: scale(0.85);
	}
	100% {
		width: 360px;
		transform: scale(0.595); /* 0.85 * 0.7 = 0.595 (30% reduction) */
	}
}

/* Phase 4: Swipe left */
.phase-swipe-left {
	animation:
		fadeInSquare 2s ease-out forwards,
		unfold 0.4s ease-out forwards,
		scaleDown 5s ease-out 0.4s forwards,
		swipeLeft 0.5s ease-in forwards;
}

@keyframes swipeLeft {
	0% {
		transform: scale(0.595) translateX(0);
		opacity: 1;
	}
	100% {
		transform: scale(0.595) translateX(-150%);
		opacity: 0;
	}
}

/* Roulette scene */
.roulette-scene {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: end;
	width: 100%;
	gap: 24px;
	/* animation: flyInFromRight 0.6s ease-out forwards; */
}

.scene-active {
	opacity: 1;
}

@keyframes flyInFromRight {
	0% {
		opacity: 0;
		transform: translateX(100%);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}

/* Exciting text */
.exciting-text {
	font-family: 'Squad', system-ui, sans-serif;
	font-weight: 900;
	font-size: 32px;
	color: white;
	text-align: center;
	text-transform: uppercase;
	opacity: 0;
	transform: scale(0.8) translateY(20px);
	transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.exciting-text.text-visible {
	opacity: 1;
	transform: scale(1) translateY(0);
}
</style>
